
import usePrices from "@/composables/usePrices";
import useStore from "@/composables/useStore";
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
    name: "SelectionSummary",
    setup() {
        const {
            computed: { selectedDiamond }
        } = useStore();
        const { t } = useI18n();

        const {
            ringbandPriceFormatted,
            diamondPriceFormatted,
            totalPriceFormatted
        } = usePrices();

        const diamondText = computed(() => {
            return `${selectedDiamond.value?.carat} ${t("components.ct")} ${t(
                `diamondProperties.shape.${selectedDiamond.value?.shape}`
            )} / ${t("components.color")}: ${
                selectedDiamond.value?.color
            } / ${t("components.clarity")}: ${selectedDiamond.value?.clarity}`;
        });

        const totalText = t("components.total");

        return {
            t,
            selectedDiamond,
            diamondText,
            ringbandPriceFormatted,
            diamondPriceFormatted,
            totalText,
            totalPriceFormatted
        };
    }
});
